import { apiGet, apiPatch, apiPost } from "./client";


export async function getTeacherById(teacherId) {
  return apiGet(`/teacher/${encodeURIComponent(teacherId)}`);
}

export async function getTeacherSubscription() {
  return apiGet("/teacher/subscription");
}

export async function getQuickStartStatus() {
  return apiGet("/teacher/me/quick-start");
}

export async function getTeacherStudents() {
  return apiGet("/teachers/students");
}

export async function ackQuickStartWorkspace() {
  return apiPost("/teacher/me/quick-start/workspace", {});
}

export async function saveItemaTourState({ status, stepId }) {
  return apiPatch(
    "/teacher/me/tours/itema",
    {
      status,
      stepId: stepId ?? null,
    },
    undefined,
    { retry: false },
  );
}

export async function saveLessonPlannerTourState({ status, stepId }) {
  return apiPatch(
    "/teacher/me/tours/lesson-planner",
    {
      status,
      stepId: stepId ?? null,
    },
    undefined,
    { retry: false },
  );
}

export async function saveLessonPlannerDefaults({ curriculum, grade, subject }) {
  return apiPatch(
    "/teacher/me/lesson-planner/defaults",
    {
      curriculum,
      grade,
      subject,
    },
    undefined,
    { retry: false },
  );
}

export async function saveTeacherOnboarding({
  teachingRoleId,
  grades,
  subjects,
  curricula,
  priorities,
}) {
  return apiPatch(
    "/teacher/me/onboarding",
    {
      teachingRoleId,
      grades,
      subjects,
      curricula,
      priorities,
    },
    undefined,
    { retry: false },
  );
}